import React from 'react';
import { Section, SectionHeading } from '../Section';
import { CtaButton } from '../CtaButton';
import { bonuses } from '../../data/bonuses';
export function Bonuses() {
  return <Section tone="darker" id="bonuses" data-id="element-96" data-mp="1cl64vgahrwk8">
      <SectionHeading eyebrow="🎁 Only with today’s offer" title="Get 5 professional bonuses free" subtitle="Five additional resources included at no extra cost when you get the Playbook today." data-id="element-97" data-mp="1clzc0idd4o2w" />

      <div className="mt-10 space-y-8" data-id="element-98" data-mp="257r4t5519gze">
        {bonuses.map(bonus => <article key={bonus.badge} className="overflow-hidden rounded-2xl border border-white/10 bg-navy-900" data-id="element-99" data-mp="20c1ymiyid1u4">
            <div className="bg-white p-2 sm:p-4" data-id="element-100" data-mp="1ra2h7pjkzvqn">
              <img src={bonus.image} alt={`${bonus.title} — ${bonus.subtitle}`} className="w-full" width={1276} height={1276} loading="lazy" data-id="element-101" data-mp="1r9kf4ca8mnat" />
            </div>
            <div className="p-5 sm:p-6" data-id="element-102" data-mp="1etexke1wu2aj">
              <span className="inline-block rounded-full bg-gold-500 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.16em] text-navy-950" data-id="element-103" data-mp="1eug88hf0kmrq">
                {bonus.badge}
              </span>
              <h3 className="mt-3 font-display text-xl font-bold leading-tight text-white sm:text-2xl" data-id="element-104" data-mp="15sp7lqzbz64q">
                {bonus.title}
              </h3>
              <p className="mt-1.5 text-[14px] font-semibold text-gold-400" data-id="element-105" data-mp="w2x7yicdjmte">{bonus.subtitle}</p>
              <p className="mt-3 text-[15px] leading-relaxed text-slate-300" data-id="element-106" data-mp="10uf6kzqxdbb7">{bonus.description}</p>
              <p className="mt-4 text-sm font-bold uppercase tracking-wide text-white" data-id="element-107" data-mp="n30nksx0pa45">
                Value: <span className="text-gold-400 line-through decoration-red-500/70" data-id="element-108" data-mp="r3kng48z6rtz">{bonus.value}</span>{' '}
                <span className="text-emerald-400" data-id="element-109" data-mp="d41g3dnznkiq">Free today</span>
              </p>
            </div>
          </article>)}
      </div>

      <div className="mt-10 flex justify-center" data-id="element-110" data-mp="i2mjtn2g8mbx">
        <CtaButton label="Get all 5 bonuses free" subLabel="Included with today’s $27 offer" data-id="element-111" data-mp="2jsto4cic00r9" />
      </div>
    </Section>;
}